<div class="h-full w-full flex flex-col justify-start items-center overflow-hidden w-full">
    <div class="w-full h-full grid grid-cols-4 gap-2">
        <!-- Left Hand Sidebar - Stepper -->
        <div class="col-span-1 h-full rounded-xl border border-gray-200 dark:border-white/10">
            <div class="h-full flex flex-col overflow-hidden divide-y divide-border">
                <!-- header -->
                <div class="px-2 py-4 drawer-header-primary overflow-hidden rounded-t-xl">
                    <div class="flex space-x-3 h-full items-center">
                        <div class="min-w-0 flex-1 px-2">
                            <p class="text-md font-semibold text-primary">
                                Build your brief
                            </p>
                            <p class="text-sm text-secondary">
                                Complete all steps to launch your brief.
                            </p>
                        </div>
                    </div>
                </div>
                <!-- header - END -->
                <!-- main content -->
                <div class="relative h-full flex-1 flex-col items-center justify-center w-full overflow-hidden p-2">
                    @for (step of steps(); track step.id; let i = $index) {
                    <button type="button" (click)="goTo(i)"
                        class="mb-0.5 flex w-full items-center gap-3 px-2 py-2.5 text-left transition-colors hover:bg-muted"
                        [class]="i === current() ? 'bg-brand-studio/10 rounded-md' : ''">

                        <span
                            class="grid size-[30px] flex-shrink-0 place-items-center rounded-full border-[1.5px] font-heading text-sm font-bold transition-all"
                            [class]="stepCircleClass(i)">
                            @if (isDone(i)) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                class="size-5 text-brand-studio" stroke-linejoin="round">
                                <path d="M20 6 9 17l-5-5" />
                            </svg>
                            } @else {
                            {{ i + 1 }}
                            }
                        </span>
                        <span>
                            <span class="block font-heading text-base font-bold leading-tight"
                                [class]="i === current() ? 'text-foreground' : 'text-foreground/80'">{{ step.label
                                }}</span>
                            <span class="block text-[11px] text-muted-foreground">{{ step.sub }}</span>
                        </span>
                    </button>
                    }
                </div>
                <!-- main content - END -->
            </div>
        </div>
        <!-- Left Hand Sidebar - Stepper - END -->

        <!-- Main Content -->
        <div class="col-span-3 h-full overflow-hidden flex flex-col gap-y-2">
            <div class="w-full flex-1 overflow-hidden">
                <div class="h-full overflow-y-auto">
                    <div class="mx-auto max-w-7xl px-6 sm:px-12">

                        @if (step().id !== 'agency-pricing') {
                        <div class="w-full flex flex-row items-center justify-between">
                            <div class="mb-7">
                                <span class="text-[11px] font-bold uppercase tracking-wider text-brand-studio">{{
                                    step().eyebrow
                                    }}</span>
                                <h2 class="mt-2.5 font-heading text-4xl font-bold leading-none tracking-tight">{{
                                    step().title
                                    }}
                                </h2>
                                <p class="mt-3 max-w-xl text-sm leading-relaxed text-muted-foreground">{{ step().desc }}
                                </p>
                            </div>

                            <div class="mb-4 flex flex-row items-center justify-end gap-x-2">
                                @if (step().templates) {
                                <button type="button" [disabled]="aiBusy()" (click)="openTemplates()"
                                    class="inline-flex items-center gap-2 rounded-full border border-brand-agency bg-brand-agency/10 px-3.5 py-1.5 text-xs font-bold text-brand-agency-dark transition-colors hover:bg-brand-agency hover:text-white disabled:opacity-50 dark:text-brand-agency">
                                    
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        class="size-3"
                                        stroke-linejoin="round">
                                        <path d="M12 17h1.5" />
                                        <path d="M12 22h1.5" />
                                        <path d="M12 2h1.5" />
                                        <path d="M17.5 22H19a1 1 0 0 0 1-1" />
                                        <path d="M17.5 2H19a1 1 0 0 1 1 1v1.5" />
                                        <path d="M20 14v3h-2.5" />
                                        <path d="M20 8.5V10" />
                                        <path d="M4 10V8.5" />
                                        <path d="M4 19.5V14" />
                                        <path d="M4 4.5A2.5 2.5 0 0 1 6.5 2H8" />
                                        <path d="M8 22H6.5a1 1 0 0 1 0-5H8" />
                                    </svg>
                                    Templates
                                </button>
                                }
                                @if (step().ai) {
                                <button type="button" [disabled]="aiBusy()" (click)="runAi(step().ai!)"
                                    class="inline-flex items-center gap-2 rounded-full border border-brand-studio bg-brand-studio/10 px-3.5 py-1.5 text-xs font-bold text-brand-studio-dark transition-colors hover:bg-brand-studio hover:text-white disabled:opacity-50 dark:text-brand-studio">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <path
                                            d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
                                    </svg>
                                    {{ aiBusy() ? 'Thinking...' : 'AI Suggestion' }}
                                </button>
                                }
                            </div>
                        </div>
                        }


                        @switch (step().id) {
                        @case ('agency-pricing') {
                        <step-agency-pricing class="w-full h-full" (modelSelected)="onModelSelected($event)" />
                        }
                        @case ('product') { <bb-product-section /> }
                        @case ('brief') { <bb-brief-basics-section /> }
                        @case ('content') { <bb-content-section /> }
                        @case ('creative') { <bb-creative-section [showMethodChooser]="true" /> }
                        @case ('audience') { <bb-audience-section /> }
                        @case ('screening') { <bb-screening-section /> }
                        @case ('review') {
                        <div class="grid grid-cols-1 gap-7 lg:grid-cols-[1fr_320px]">
                            <div class="flex flex-col gap-4">
                                <div class="rounded-xl border border-border bg-card p-6">
                                    <div class="mb-3.5 font-heading text-xl font-bold">Pre-flight checklist</div>
                                    <div class="flex flex-col gap-2.5">
                                        @for (item of checklist(); track item.label) {
                                        <div class="flex items-center gap-2.5 text-sm font-medium">
                                            <span class="grid size-[22px] place-items-center rounded-full"
                                                [class]="item.ok ? 'bg-green-500/15 text-green-600' : 'bg-muted text-muted-foreground'">
                                                @if (item.ok) {
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                                    <path d="M20 6 9 17l-5-5" />
                                                </svg>
                                                } @else {
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                                    <path d="M5 12h14" />
                                                </svg>
                                                }
                                            </span>
                                            {{ item.label }}
                                        </div>
                                        }
                                    </div>
                                </div>
                                @if (essentialsComplete()) {
                                <div
                                    class="rounded-lg border border-green-500/30 bg-green-500/[0.06] px-4 py-3.5 text-[13px] font-semibold text-green-700 dark:text-green-400">
                                    All essentials complete — this brief is ready to launch.</div>
                                } @else {
                                <div
                                    class="rounded-lg border border-amber-500/30 bg-amber-500/[0.06] px-4 py-3.5 text-[13px] text-amber-700 dark:text-amber-400">
                                    A few essentials are still missing. You can launch once they're complete.</div>
                                }
                            </div>
                            <bb-summary-card />
                        </div>

                        <div class="mt-9 border-t border-border pt-8">
                            <bb-compensation-section />
                        </div>

                        <hr class="border-border" />

                        <!-- Brief settings -->
                        <div class="mt-9 border-t border-border pt-8">
                            <div class="font-heading text-lg font-bold">Brief settings</div>
                            <div *appHasRole="[4,6]"
                                class="flex items-start justify-between gap-4 border-b border-border py-3">
                                <div class="max-w-[70%]">
                                    <div class="font-heading text-base font-bold">Manual payment approval</div>
                                    <div class="mt-0.5 text-xs text-muted-foreground">Hold creator payouts for manual
                                        sign-off.</div>
                                </div>
                                <bb-switch [checked]="service.noAutoPayment()" ariaLabel="Manual payment approval"
                                    (checkedChange)="service.noAutoPayment.set($event)" />
                            </div>
                            <div class="flex items-start justify-between gap-4 py-3">
                                <div class="max-w-[70%]">
                                    <div class="font-heading text-base font-bold">List publicly</div>
                                    <div class="mt-0.5 text-xs text-muted-foreground">Show this brief in the public
                                        creator
                                        marketplace.</div>
                                </div>
                                <bb-switch [checked]="service.isPublic()" ariaLabel="List publicly"
                                    (checkedChange)="service.isPublic.set($event)" />
                            </div>
                        </div>

                        }
                        }


                    </div>
                </div>
            </div>
            @if (step().id !== 'agency-pricing') {
            <div
                class="shrink-0 w-full px-4 py-2 rounded-xl border border-gray-200 dark:border-white/10 flex flex-row items-center justify-between">
                <div class="flex-1 flex flex-row items-center justify-start gap-x-4">
                    <button type="button" class="secondary-button inline-flex items-center gap-2 disabled:opacity-40"
                        [disabled]="current() === 0" (click)="back()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="m12 19-7-7 7-7" />
                            <path d="M19 12H5" />
                        </svg>
                        Back
                    </button>

                    <div class="max-w-sm flex-1">
                        <div class="h-1.5 overflow-hidden rounded-full bg-muted">
                            <span class="block h-full rounded-full bg-brand-studio transition-all"
                                [style.width.%]="progressPct()"></span>
                        </div>
                        <div class="mt-1.5 text-[11px] text-muted-foreground">Step {{ current() + 1 }} of {{
                            steps().length }} ·
                            {{ essentialsDone() }}/{{ checklist().length }} essentials done</div>
                    </div>
                </div>

                <div class="shrink-0 flex flex-row items-center justify-end gap-x-4">
                    @if (isLast()) {
                    <button type="button" class="flashy-go-button disabled:opacity-50"
                        [disabled]="!essentialsComplete()" (click)="launch.emit()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-4">
                            <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
                            <path
                                d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09" />
                            <path
                                d="M9 12a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.4 22.4 0 0 1-4 2z" />
                            <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 .05 5 .05" />
                        </svg>
                        Launch brief
                    </button>
                    } @else {
                    <button type="button" class="flashy-go-button" data-guide-id="createBrief.continue" (click)="next()">
                        Continue
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M5 12h14" />
                            <path d="m12 5 7 7-7 7" />
                        </svg>
                    </button>
                    }
                </div>
            </div>
            }
        </div>
        <!-- Main Content - END -->
    </div>

    <atom-brief-template-drawer #briefTemplateDrawer (templateCreated)="onBriefTemplateCreated($event)"
        (templateSelected)="onBriefTemplateCreated($event)" />

</div>